"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _Auth = require("../constants/Auth");

var initState = {
  loading: false,
  message: '',
  showMessage: false,
  redirect: '',
  token: localStorage.getItem(_Auth.AUTH_TOKEN)
};

var auth = function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _Auth.AUTHENTICATED:
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        loading: false,
        redirect: '/',
        token: action.token
      });

    case _Auth.SHOW_AUTH_MESSAGE:
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        message: action.message,
        showMessage: true,
        loading: false
      });

    case _Auth.HIDE_AUTH_MESSAGE:
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
        message: '',
        showMessage: false
      });

    case _Auth.SIGNOUT_SUCCESS:
      {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
          token: null,
          redirect: '/',
          loading: false
        });
      }

    case _Auth.SIGNUP_SUCCESS:
      {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
          loading: false,
          token: action.token
        });
      }

    case _Auth.SHOW_LOADING:
      {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
          loading: true
        });
      }

    case _Auth.SIGNIN_WITH_GOOGLE_AUTHENTICATED:
      {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
          loading: false,
          token: action.token
        });
      }

    case _Auth.SIGNIN_WITH_FACEBOOK_AUTHENTICATED:
      {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
          loading: false,
          token: action.token
        });
      }

    default:
      return state;
  }
};

var _default = auth;
exports.default = _default;